import { useServiceWorkerUpdateToast } from "@/utilities/useServiceWorkerUpdateToast";

export const ServiceWorkerToast = () => {
  useServiceWorkerUpdateToast();
  return <> </>;
};
